'use client';

import { useEffect } from 'react';
import { logClientError } from '@/lib/client-error-logger';

// Đăng ký Service Worker cache ASSET TĨNH (public/sw.js) — xem comment đầu file đó cho lý lẽ đầy đủ.
// Chạy sau mount, không chặn render; lỗi đăng ký (trình duyệt cũ, chế độ riêng tư chặn SW...) chỉ log,
// KHÔNG toast — mất tác dụng cache là suy giảm hiệu năng, không phải lỗi chức năng user cần biết ngay.
export function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register('/sw.js').catch(err => {
      logClientError({ route: 'components/ServiceWorkerRegister', action: 'register_sw',
        message: err instanceof Error ? err.message : String(err) });
    });
  }, []);
  return null;
}
